import api from "./axiosInstance";

export const getPayees = async (limit = 10, offset = 0) => {
  const res = await api.get(`api/v1/payees/?limit=${limit}&offset=${offset}`);
  return res.data;
};

export const getAllPayees = async () => {
  const res = await api.get("api/v1/payees/?limit=100&offset=0");
  console.log('--', res);
  return res.data;
};

export const createPayee = async (payload) => {
  const res = await api.post(`api/v1/payees/`, payload);
  return res.data;
};

export const updatePayee = async (id, payload) => {
  const res = await api.patch(`api/v1/payees/${id}/`, payload);
  return res.data;
};

export const deletePayee = async (id) => {
  await api.delete(`api/v1/payees/${id}/`);
};
